// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import { LuBuilding2, LuCalendarClock } from 'react-icons/lu';

import { VIEW_SC_STRINGS } from '@/constant/smartCooler/smartCooler.constant';
import { APP_BORDER } from '@/constant/theme/colors.constant';
import { getDateTime } from '@/utils/dateTime';
import { getLabelIcon, getSectionIcon } from '@/components/atoms/IconMap';
import { SectionCard } from '@/components/organism/Cards/SectionCard';
import { StatCell } from '@/components/organism/Cards/StatCell';
import PillCell from '@/components/organism/StatusPills/PillCell';
import { ISmartCooler } from '../smartCooler.interface';

interface Props {
  item: ISmartCooler;
}

export const ViewSCOverviewTab: React.FC<Props> = ({ item }) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Identity */}
      <SectionCard
        title={VIEW_SC_STRINGS.SECTION_IDENTITY_TITLE}
        icon={getSectionIcon('Identity')}
        subtitle={VIEW_SC_STRINGS.SECTION_IDENTITY_SUB}
        bodyClassName=""
      >
        <div
          className={classNames(
            'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x divide-y',
            APP_BORDER.divideSoft,
          )}
        >
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_COOLER_ID)}
            label={VIEW_SC_STRINGS.LABEL_COOLER_ID}
            value={item.coolerId}
            mono
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_NATIVE_ID)}
            label={VIEW_SC_STRINGS.LABEL_NATIVE_ID}
            value={item.nativeId}
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_DEVICE_ID)}
            label={VIEW_SC_STRINGS.LABEL_DEVICE_ID}
            value={item.deviceId}
            mono
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_DEVICE_SN)}
            label={VIEW_SC_STRINGS.LABEL_DEVICE_SN}
            value={item.deviceSn}
            mono
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_READER_SN)}
            label={VIEW_SC_STRINGS.LABEL_READER_SN}
            value={item.readerSn}
            mono
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_DEVICE_TYPE)}
            label={VIEW_SC_STRINGS.LABEL_DEVICE_TYPE}
            value={
              item.deviceType ? (
                <PillCell
                  value={item.deviceType}
                  config={{
                    bg: 'bg-blue-50 dark:bg-blue-950/40',
                    text: 'text-blue-700 dark:text-blue-300',
                    border: 'border-blue-200 dark:border-blue-800',
                  }}
                  shape="badge"
                  size="text-[11px]"
                  className="font-semibold border uppercase"
                />
              ) : undefined
            }
          />
        </div>
      </SectionCard>

      {/* Operator */}
      <SectionCard
        title={VIEW_SC_STRINGS.SECTION_OPERATOR_TITLE}
        icon={<LuBuilding2 className="w-4 h-4" />}
        subtitle={VIEW_SC_STRINGS.SECTION_OPERATOR_SUB}
        bodyClassName=""
      >
        <div
          className={classNames(
            'grid grid-cols-1 sm:grid-cols-3 divide-x divide-y',
            APP_BORDER.divideSoft,
          )}
        >
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_OPERATOR_ID)}
            label={VIEW_SC_STRINGS.LABEL_OPERATOR_ID}
            value={item.operatorId}
            mono
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_PARTNER_UID)}
            label={VIEW_SC_STRINGS.LABEL_PARTNER_UID}
            value={item.partnerUid}
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_MARKET_ID)}
            label={VIEW_SC_STRINGS.LABEL_MARKET_ID}
            value={item.marketId}
            mono
          />
        </div>
      </SectionCard>

      {/* Timestamps */}
      <SectionCard
        title={VIEW_SC_STRINGS.SECTION_TIMESTAMPS_TITLE}
        icon={<LuCalendarClock className="w-4 h-4" />}
        subtitle={VIEW_SC_STRINGS.SECTION_TIMESTAMPS_SUB}
        bodyClassName=""
      >
        <div
          className={classNames(
            'grid grid-cols-1 sm:grid-cols-2 divide-x divide-y',
            APP_BORDER.divideSoft,
          )}
        >
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_CREATED_ON)}
            label={VIEW_SC_STRINGS.LABEL_CREATED_ON}
            value={getDateTime(item.createdOn)}
          />
          <StatCell
            size="md"
            labelIcon={getLabelIcon(VIEW_SC_STRINGS.LABEL_UPDATED_ON)}
            label={VIEW_SC_STRINGS.LABEL_UPDATED_ON}
            value={getDateTime(item.updatedOn)}
          />
        </div>
      </SectionCard>
    </div>
  );
};
